import React, { useState, useEffect, FC } from "react";
import { useLocation } from "react-router-dom";
import {
  HeaderWrapper,
  Logo,
  NavLink,
  MobileMenuButton,
  MobileNav,
  MobileNavLink,
  CloseButton,
} from "./Header.styled";
import LanguageSwitcher from "./switcher/Switcher";
import i18n from "../../i18n/i18n";

const Header: FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const t = (key: string, defaultValue?: string) =>
    (i18n as any).t(key, defaultValue);
  // Control scroll state
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu when page changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Prevent scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);
  return (
    <HeaderWrapper className={isScrolled ? "scrolled" : ""}>
      <Logo to="/">{t("common:logoText", "CassioDev")}</Logo>{" "}
      <MobileMenuButton
        onClick={() => setMenuOpen(true)}
        aria-label={t("common:menuOpen", "Open navigation menu")}
        aria-expanded={menuOpen}
      >
        <i className="ph ph-list" aria-hidden="true"></i>
      </MobileMenuButton>
      <nav aria-label={t("common:menuOpen", "Main navigation menu")}>
        <NavLink to="/" active={currentPath === "/" ? "true" : undefined}>
          {t("navigation:home", "Home")}
        </NavLink>{" "}
        <NavLink
          to="/about"
          active={currentPath === "/about" ? "true" : undefined}
        >
          {t("navigation:about", "About")}
        </NavLink>
        <NavLink
          to="/skills"
          active={currentPath === "/skills" ? "true" : undefined}
        >
          {t("navigation:skills", "Skills")}
        </NavLink>
        <NavLink
          to="/testimonials"
          active={currentPath === "/testimonials" ? "true" : undefined}
        >
          {t("navigation:testimonials", "Testimonials")}
        </NavLink>
        {/* Projects and Research removed from header navigation */}
        <NavLink
          to="/contact"
          active={currentPath === "/contact" ? "true" : undefined}
        >
          {t("navigation:contact", "Contact")}{" "}
        </NavLink>
      </nav>{" "}
      <div style={{ display: "flex", alignItems: "center" }}>
        <LanguageSwitcher />
      </div>{" "}
      <MobileNav
        isOpen={menuOpen}
        aria-label="Mobile navigation menu"
        aria-hidden={!menuOpen}
        role="dialog"
      >
        {" "}
        <CloseButton
          onClick={() => setMenuOpen(false)}
          aria-label={t("common:menuClose", "Close navigation menu")}
        >
          <i className="ph ph-x" aria-hidden="true"></i>
        </CloseButton>
        <MobileNavLink to="/" active={currentPath === "/" ? "true" : undefined}>
          {t("navigation:home", "Home")}
        </MobileNavLink>{" "}
        <MobileNavLink
          to="/about"
          active={currentPath === "/about" ? "true" : undefined}
        >
          {t("navigation:about", "About")}
        </MobileNavLink>
        <MobileNavLink
          to="/skills"
          active={currentPath === "/skills" ? "true" : undefined}
        >
          {t("navigation:skills", "Skills")}
        </MobileNavLink>
        <MobileNavLink
          to="/testimonials"
          active={currentPath === "/testimonials" ? "true" : undefined}
        >
          {t("navigation:testimonials", "Testimonials")}
        </MobileNavLink>
        {/* Projects and Research removed from mobile navigation */}
        <MobileNavLink
          to="/contact"
          active={currentPath === "/contact" ? "true" : undefined}
        >
          {t("navigation:contact", "Contact")}
        </MobileNavLink>
      </MobileNav>
    </HeaderWrapper>
  );
};

export default Header;
